// src/components/sustainability/EcoMaterials.js
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { fadeIn, slideIn } from '../../utils/gsapAnimations';

function EcoMaterials({ content }) {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    fadeIn(textRef.current, 0.3);
    slideIn(imageRef.current, 'left', 0.5);
  }, []);

  return (
    <div className="flex flex-col lg:flex-row items-center py-12 px-4 gap-8">
      <div ref={textRef} className="w-full lg:w-1/2 text-center lg:text-left">
        <h2 className="text-2xl font-lora font-semibold text-primary mb-4">
          {content?.title || 'Eco-Friendly Materials'}
        </h2>
        <p className="text-poppins mb-4">
          {content?.description ||
            'We use 100% organic cotton, recycled polyester, and other sustainable fibers to create clothing that’s gentle on the planet. Our materials are sourced from certified suppliers committed to environmental stewardship.'}
        </p>
        <Link to="/shop">
          <Button className="bg-primary text-cream px-6 py-3 text-lg font-montserrat rounded-full hover:bg-primary/90">
            {content?.buttonText || 'Shop Sustainable'}
          </Button>
        </Link>
      </div>
      <div ref={imageRef} className="w-full lg:w-1/2">
        <img
          src={content?.image || 'https://via.placeholder.com/600x400?text=Eco+Materials'}
          alt={content?.imageAlt || 'Eco Materials'}
          className="w-full h-auto rounded-lg"
        />
      </div>
    </div>
  );
}

export default EcoMaterials;